var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.catapultBanner)?_c(_setup.CatapultBanner,{attrs:{"catapult-banner":_setup.catapultBanner}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }